import { render, staticRenderFns } from "./SubmitFeedbackAction.vue?vue&type=template&id=14a00d68&"
import script from "./SubmitFeedbackAction.vue?vue&type=script&lang=js&"
export * from "./SubmitFeedbackAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports